import {Grid, Group, Page} from "@/comn/components";
import {APIS, PGEUIDS, SG_SCRN_LIST} from "@/tra/tancis/ptli/ptl/authmenu/services/PtliAuthMenuService";
import {useFetch, useGrid, usePage, useToast} from "@/comn/hooks";
import {useEffect} from "react";

/*
 * Screen List Popup
 * !== 화면 목록 팝업 ==!
 */
export const PTLI1015004Q = (props:any) => {
    const {pgeUid}     = usePage({pgeUid: PGEUIDS.ptli1015004q})
    const toast  = useToast();

    const grid = { scrnList: useGrid({ defaultSchema: SG_SCRN_LIST }) }

    const fetch = {
        getScrnList: useFetch({
            api:  (data:any) => APIS.getScrnList(data),
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        })
    }

    useEffect(() => {
        grid.scrnList.setOption("height", 200);
        fetch.getScrnList.fetch(props);
    }, []);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.scrnList.grid}
                              data={fetch.getScrnList.data?.scrnList}/>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    )
}